export function i18nPrefixConcat(key: string, i18nPrefix: string, concatChar = '.'): string {
  return `${i18nPrefix}${concatChar}${key}`;
}
